export const getSortDirectionOptionsByFieldType = (
  fieldType: string,
): Array<Record<string, unknown>> => {
  switch (fieldType) {
    case "checklistfield":
    case "colorpickerfield":
    case "commentscountfield":
    case "datefield":
    case "duedatefield":
    case "firstcreatedfield":
    case "lastupdatedfield":
    case "numberfield":
    case "phonefield":
    case "recordidfield":
    case "votefield":
    case "daterangefield":
    case "currencyfield":
    case "percentcompletefield":
    case "timefield":
    case "percentfield":
    case "ratingfield":
    case "numbersliderfield":
    case "countfield":
    case "rollupfield":
    case "durationfield":
    case "autonumberfield":
      return [
        {
          value: "ASC",
          label: "1 -> 9",
        },
        {
          value: "DESC",
          label: "9 -> 1",
        },
      ];
    case "multipleselectfield":
    case "singleselectfield":
    case "statusfield":
    case "tagsfield":
      return [
        {
          value: "ASC",
          label: "First -> Last",
        },
        {
          value: "DESC",
          label: "Last -> First",
        },
      ];
    case "yesnofield":
      return [
        {
          value: "ASC",
          label: "\u2611 -> \u2610",
        },
        {
          value: "DESC",
          label: "\u2610 -> \u2611",
        },
      ];
    case "addressfield":
    default:
      return [
        {
          value: "ASC",
          label: "A -> Z",
        },
        {
          value: "DESC",
          label: "Z -> A",
        },
      ];
  }
};
